import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-33198623"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "video-warp"
};
const _hoisted_2 = {
  key: 0,
  id: "media-play-warp",
  style: {
    "width": "100%",
    "height": "100%"
  },
  ref: "videoRef",
  class: "video-player"
};
const _hoisted_3 = {
  key: 1,
  class: "video-error-warp"
};
import ShakaJsPlayer from 'xgplayer-shaka';
import HlsJsPlayer from 'xgplayer-hls.js';
import { ref, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { elMessage } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    url: {
      type: String,
      defautl: ''
    },
    autoPlay: {
      type: Boolean,
      default: false
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props; // import Player from 'xgplayer';

    const {
      t
    } = useI18n();
    const videoPlayer = ref(null); // 播放器实例
    //父组件传过来的url

    const videoError = ref(false);
    const timer = ref(null); // =========================1，区分播放器类别，销毁之前的播放器===================

    const initPlayer = async () => {
      videoError.value = false;

      if (videoPlayer.value) {
        await videoPlayer.value.destroy(true);
        videoPlayer.value = null;
      }

      let mediaPlayWarpDom = document.querySelector('#media-play-warp');
      mediaPlayWarpDom ? mediaPlayWarpDom.innerHTML = '' : '';
      setTimeout(() => {
        const videoType = /.*(\.m3u8)$/.test(props.url) ? 'HlsJsPlayer' : 'ShakaJsPlayer'; //========================== 2，开始实例化,组件仅支持dash、hls格式的视频======================

        switch (videoType) {
          case 'ShakaJsPlayer':
            videoPlayer.value = new ShakaJsPlayer({
              id: 'media-play-warp',
              url: props.url,
              // width: 624,
              // height: 351,
              lang: 'en',
              fitVideoSize: 'auto',
              autoplay: true // cors: true,
              // crossOrigin: false,
              // currentSrc: props.url
              // errorTips: `请<span>刷新</span>试试`
              //   ignores: ['progress', 'time'] //去掉播放时长及进度条

            });
            break;

          case 'HlsJsPlayer':
            videoPlayer.value = new HlsJsPlayer({
              id: 'media-play-warp',
              url: props.url,
              // width: 624,
              // height: 351,
              lang: 'en',
              fitVideoSize: 'auto',
              autoplay: true // cors: true,
              // crossOrigin: false,
              // currentSrc: props.url
              // errorTips: `请<span>刷新</span>试试`

            });
            break;
        } // videoPlayer.value.play();
        // props.autoPlay && videoPlayer.value.play();


        videoPlayer.value.once('complete', e => {
          timer.value = setInterval(() => {
            if (!videoPlayer.value) {
              clearInterval(timer.value);
              return;
            }

            if (videoPlayer.value && videoPlayer.value.networkState == 'Audio/video has not been initialized') {
              showErrorPlay();
              clearInterval(timer.value);
            }
          }, 5000);
        });
        videoPlayer.value.on('error', e => {
          timer.value && clearInterval(timer.value);
          showErrorPlay();
        }); // 监听 hls格式视频播放的错误

        videoPlayer.value.on('HLS_ERROR', e => {
          timer.value && clearInterval(timer.value);
          showErrorPlay();
        });
      }, 300);
    };

    const showErrorPlay = () => {
      !isDestroy.value && elMessage('error', '播放失败,请刷新重试');
      setTimeout(() => {
        videoError.value = true;
      }, 1000);
    }; // 监听播放路径的变化


    watch(() => props.url, async val => {
      if (val) {
        timer.value && clearInterval(timer.value);
        initPlayer();
      }
    }, {
      immediate: true,
      deep: true
    }); // 暴露销毁播放器实例的方法

    const destroyVideo = () => {
      if (videoPlayer.value) {
        videoPlayer.value.destroy(true);
        videoPlayer.value = null;
        videoError.value = false;
      }
    };

    expose({
      destroyVideo
    }); // 组件是否销毁

    const isDestroy = ref(false);
    onUnmounted(() => {
      isDestroy.value = true;
      timer.value && clearInterval(timer.value);
      timer.value = null;
      videoPlayer.value && videoPlayer.value.destroy(true);
      videoPlayer.value = null;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!videoError.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, null, 512)) : _createCommentVNode("", true), videoError.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", null, _toDisplayString(_unref(t)('视频播放失败,请')), 1), _createElementVNode("span", {
        onClick: initPlayer,
        class: "pointer",
        style: {
          "margin": "0 6px",
          "color": "red"
        }
      }, _toDisplayString(_unref(t)('刷新_s')), 1), _createElementVNode("span", null, _toDisplayString(_unref(t)('重试_s')), 1)])) : _createCommentVNode("", true)]);
    };
  }

});